import { render, staticRenderFns } from "./forms-category-modal.vue?vue&type=template&id=21460cd9&"
import script from "./forms-category-modal.vue?vue&type=script&lang=js&"
export * from "./forms-category-modal.vue?vue&type=script&lang=js&"
import style0 from "./forms-category-modal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports